module.exports = __webpack_public_path__ + "static/media/WEX-USDC.7399d3e7.png";